const ProjectData = [
    {
        id: 1,
        eventtheme: "#E2CCC2",
    },
    {
        id: 2,
        eventtheme: "#C2E2CF",
    },
    {
        id: 3,
        eventtheme: "#DCD0EB",
    },
    {
        id: 4,
        eventtheme: "#C1D7EB",
    },
    {
        id: 1,
        eventtheme: "#E2CCC2",
    },
    {
        id: 2,
        eventtheme: "#C2E2CF",
    },
    {
        id: 3,
        eventtheme: "#DCD0EB",
    },
    {
        id: 4,
        eventtheme: "#C1D7EB",
    },
];
export default ProjectData